import { Boxes, Truck, CheckCircle2, KeyRound, MapPin, Sparkles } from "lucide-react";
import { motion } from "framer-motion";

const ITEMS = [
    { icon: MapPin, label: "Moving to Toronto" },
    { icon: Truck, label: "GTA Move Coordination" },
    { icon: KeyRound, label: "Rental Viewing Support" },
    { icon: Boxes, label: "Packing Support" },
    { icon: Sparkles, label: "Cleaning Coordination" },
    { icon: CheckCircle2, label: "Move-Day Planning" },
    { icon: Sparkles, label: "Clear Pricing" },
    { icon: MapPin, label: "Trusted Local Support" },
];

export default function Marquee() {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="marquee"
            className="marquee-pause relative overflow-hidden border-y border-[#ECE4D3] bg-white py-5"
        >
            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="marquee-track"
            >
                {row.map((it, i) => {
                    const Icon = it.icon;
                    return (
                        <div
                            key={i}
                            className="flex shrink-0 items-center gap-3 px-7 text-[15px] font-semibold tracking-tight text-[#0E2A47]"
                        >
                            <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#FDF1E7] text-[#F26B1F]">
                                <Icon size={16} strokeWidth={2} />
                            </span>
                            {it.label}
                            <span className="ml-2 h-1.5 w-1.5 rounded-full bg-[#F26B1F]" />
                        </div>
                    );
                })}
            </motion.div>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />
        </div>
    );
}
